import { BrowserRouter } from "react-router-dom";
import NavbarMain from "./components/Navbar";
import FooterMain from "./components/Footer";
import { Provider } from "react-redux";
import { store } from "./Redux/ReduxParent";
import { createContext, useEffect, useState } from "react";
import Aos from "aos";
import Pages from "./Pages";
import a from "./images/V-tr-L.png";
import b from "./images/V-tr-R.png";
import c from "./images/V-red-T.png";
import d from "./images/V-blue-B.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const contextpass = createContext();

function App() {
  const [mode, setmode] = useState(false);
  const [sicon, setsicon] = useState(false);
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <contextpass.Provider
      value={{
        pass: [mode, setmode],
        social: [sicon, setsicon],
      }}
    >
      <Provider store={store}>
        <div>
          <img src={a} alt="a" className="a" />
          <img src={b} alt="b" className="b" />
          <img src={c} alt="c" className="c" />
          <img src={d} alt="d" className="d" />
        </div>
        <div className="container-fluid p-0 scroller" >
          <BrowserRouter>
            <NavbarMain />
            <Pages />
            <FooterMain />
          </BrowserRouter>
        </div>
      </Provider>
    </contextpass.Provider>
  );
}

export default App;
export { contextpass };
